import React, { useEffect, useState } from "react";
import { useAuth } from "../../components/context/Auth";
import styles from "./Product.module.css";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import Button from "../../components/updatedComponents/Dealers/Button";
import { AddStyle, DeleteTo, EditeTo, SettingTo, ViewTo, } from "../../components/icons/Icon3";
import { useNavigate, useParams } from "react-router-dom";
import StyleTypeCard from "../../components/updatedComponents/Product/StyleTypeCard";
import { TextColorCode } from "../../Utils/TextUtils";
import fetchData from "../../APIsControll/apiControll";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
const ViewProduct = () => {
  const { mode, managerId } = useAuth();
  const { product } = useParams();
  const { show } = useToast();
  const navi = useNavigate();
  const product_id = new URLSearchParams(window.location.search).get("product_id");
  const [data, setData] = useState();
  const [ProductSerach, setProductSerach] = useState('');
  const [filteredData, setFilteredData] = useState(null);
  const [modeleContiner, setModelContiner] = useState(null);
  const [modelToggle, setModelToggle] = useState(false);
  const [loading, setLoading] = useState({ productInfo: false, deleteProduct: false, });

  const DeleteItem = async (id, type) => {
    setLoading({ ...loading, deleteProduct: true });
    try {
      const payload = { managerId: managerId, _id: id };
      let endpoint = "";
      if (type === "styles") {
        endpoint = "content/deleteStyle";
      } else if (type === "types") {
        endpoint = "content/deleteType";
      } else if (type === "collections") {
        endpoint = "content/deleteCollection";
      }
      if (endpoint) {
        const res = await fetchData(endpoint, payload);
        if (res && res.status === "success") {
          show(res.msg || res.data, "success");
          getOrderInfo();
          setModelToggle(false);
          return;
        }
        if (res && res.status === "failed") {
          show(res.msg || "Something went wrong", "error");
          return;
        } else {
          show("Unexpected response format", "error");
          return;
        }
      } else {
        show("Invalid type provided", "error");
        return;
      }
    } catch (error) {
      show("An error occurred while processing your request.", "error");
    } finally {
      setLoading({ ...loading, deleteProduct: false });
    }
  };

  const handleSetModel = (item) => {
    setModelToggle(true);
    setModelContiner(item);
  };

  async function getOrderInfo() {
    setLoading({ ...loading, productInfo: true });

    try {
      const payload = { product_id: product_id, };
      const res = await fetchData(`content/productInfo`, payload);
      if (res.status === "success") {
        setData(res);
        setFilteredData(res);
        return;
      }
      if (res.status === "failed") {
        show(res.msg, "error");
        return;
      }
    } catch (error) {
    } finally {
      setLoading({ ...loading, deleteProduct: false });
    }
  }

  useEffect(() => {
    if (ProductSerach.trim() === '') {
      setFilteredData(data);
      return;
    }
    const searchTerm = ProductSerach.toLowerCase();
    const filteredStyles = data?.styles?.filter(item =>
      item.style_name.toLowerCase().includes(searchTerm)
    ) || [];
    const filteredTypes = data?.types?.filter(item =>
      item.type_name.toLowerCase().includes(searchTerm)
    ) || [];
    const filteredCollections = data?.collections?.filter(item =>
      item.collection_name.toLowerCase().includes(searchTerm)
    ) || [];
    setFilteredData({
      ...data,
      styles: filteredStyles,
      types: filteredTypes,
      collections: filteredCollections
    });

  }, [ProductSerach, data]);



  useEffect(() => {
    getOrderInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product_id]);

  return (
    <div className={styles.Main_Layout}>
      <ModalWrapper isOpen={modelToggle} onClose={() => setModelToggle(false)}>
        {modeleContiner}
      </ModalWrapper>
      <div
        className={styles.Layout}
        style={{
          backgroundColor: mode ? "#2B2D31" : "#F8F9FC",
          color: mode ? "#fff" : "#000",
        }}
      >
        <div className={styles.Top_bar_css}>
          <div>
            <TopTabBar text={`Products / ${product}`} />
          </div>
          <div className={styles.btn_Continer}>
            <div>
              <InputTag
                placeholderText={"Search.."}
                placeholderType={"text"}
                padding={"10px"}
                fontSize={"12px"}
                maxLength={20}
                onChange={(e) => setProductSerach(e.target.value)}
              />
            </div>
            <div>
              <Button
                buttonBgColor={mode ? "#232529" : "#fff"}
                buttonIcon={<AddStyle mode={mode} />}
                buttonText={"Add View / FAQ"}
                buttonTextColor={mode ? "#fff" : "#646B88"}
                buttonClick={() => navi(`/products/${product}/faq?productId=${product_id}`)}
              />
            </div>
            <div>
              <Button
                buttonBgColor={mode ? "#232529" : "#fff"}
                buttonIcon={<AddStyle mode={mode} />}
                buttonText={"Add Style"}
                buttonTextColor={mode ? "#fff" : "#646B88"}
                buttonClick={() => navi(`/products/addstyle/${product}/${product_id}`)}
              />
            </div>
            <div>
              <Button
                buttonBgColor={mode ? "#232529" : "#fff"}
                buttonIcon={<AddStyle mode={mode} />}
                buttonText={"Add Type"}
                buttonTextColor={mode ? "#fff" : "#646B88"}
                buttonClick={() => navi(`/products/addtype/${product}/${product_id}`)}
              />
            </div>
            <div>
              <Button
                buttonBgColor={mode ? "#232529" : "#fff"}
                buttonIcon={<AddStyle mode={mode} />}
                buttonText={"Add Collection"}
                buttonClick={() => navi(`/products/product/addcollection/${product}?productId=${product_id}`)}
                buttonTextColor={mode ? "#fff" : "#646B88"}
              />
            </div>
          </div>
        </div>
        <div className={mode ? styles.Scroll_con : styles.Scroll_con_light}>
          <div className={styles.Style_continer}>
            <div
              className={styles.Style_continer_text}
              style={{ color: mode ? "#fff" : "#646B88" }}
            >
              {" "}
              <span style={{ borderBottom: "2px solid" }}>Style </span>{" "}
            </div>
            <div className={styles.Style_Card_continer}>
              {loading.productInfo
                ? Array.from({ length: 4 }).map((_, index) => (
                  <div key={index} style={{ width: "100%" }}>
                    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", gap: "10px", }}  >
                      <div style={{ width: "100%" }}>
                        <Skeleton
                          thickness={6}
                          shape="circle"
                          width="50px"
                          height="50px"
                        />
                        <div style={{ width: "75%" }}>
                          <Skeleton lines={3} thickness={1} />
                        </div>
                        <Skeleton lines={1} thickness={3} />
                      </div>
                    </div>
                  </div>
                ))
                :
                filteredData?.styles?.map((item, i) => (
                  <div
                    onClick={() => navi(`/products/addstyle/${product}/${product_id}?disabled=${true}&type_id=${item?._id}`)}
                    key={`styles - ${i}`}
                  >
                    <StyleTypeCard
                      Status={item?.status}
                      Text={item?.style_name}
                      ststusIcon={item?.status}
                      imgUrl={item?.logo}
                      DeleteClick={() =>
                        handleSetModel(
                          <>
                            <ManagerModal
                              heading={"Delete Product"}
                              centerHeading={
                                "Are you sure you want to Delete?"
                              }
                              subHeading={
                                "To confirm! type delete in the text field."
                              }
                              targetWord={"delete"}
                              handleSubmit={() => {
                                DeleteItem(item._id, "styles");
                              }}
                              handleCloseModal={() => setModelToggle(false)}
                            />
                          </>
                        )
                      }
                      EditeClick={() => navi(`/products/addstyle/${product}/${product_id}?type_id=${item?._id}`)}
                    />
                  </div>
                ))}
            </div>
          </div>
          <div className={styles.Style_continer}>
            <div className={styles.Style_continer_text}
              style={{ color: mode ? "#fff" : "#646B88" }}
            >
              {" "}
              <span style={{ borderBottom: "2px solid" }}>Type</span>{" "}
            </div>
            <div className={styles.Style_Card_continer}>
              {loading.productInfo
                ? Array.from({ length: 4 }).map((_, index) => (
                  <div key={index} style={{ width: "100%" }}>
                    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", gap: "10px", }}  >
                      <div style={{ width: "100%" }}>
                        <Skeleton
                          thickness={6}
                          shape="circle"
                          width="50px"
                          height="50px"
                        />
                        <div style={{ width: "75%" }}>
                          <Skeleton lines={3} thickness={1} />
                        </div>
                        <Skeleton lines={1} thickness={3} />
                      </div>
                    </div>
                  </div>
                ))
                :
                filteredData?.types?.map((item, i) => (
                  <div onClick={() => navi(`/products/addtype/${product}/${product_id}?type_id=${item?._id}&disabled=${true}`)}>
                    <StyleTypeCard
                      Status={item?.status}
                      Text={item?.type_name}
                      ststusIcon={item?.status}
                      imgUrl={item?.logo}
                      DeleteClick={() =>
                        handleSetModel(
                          <>
                            <ManagerModal
                              heading={"Delete Product"}
                              centerHeading={"Are you sure you want to Delete?"}
                              subHeading={
                                "To confirm! type delete in the text field."
                              }
                              targetWord={"delete"}
                              handleSubmit={() => {
                                DeleteItem(item._id, "types");
                              }}
                              handleCloseModal={() => setModelToggle(false)}
                            />
                          </>
                        )
                      }
                      EditeClick={() => navi(`/products/addtype/${product}/${product_id}?type_id=${item?._id}`)}
                      key={`types - ${i}`}
                    />
                  </div>
                ))}
            </div>
          </div>
          <div className={styles.Style_continer}>
            <div
              className={styles.Style_continer_text}
              style={{ color: mode ? "#fff" : "#646B88" }}
            >
              {" "}
              <span style={{ borderBottom: "2px solid" }}>Collection</span>{" "}
            </div>
            <div className={styles.container} style={{ marginBottom: "-10px" }}>
              <ul className={styles.responsiveTable}>
                <li
                  className={styles.tableHeader}
                  style={
                    mode
                      ? { backgroundColor: "#232529", color: "#fafafa" }
                      : { backgroundColor: "#D9DCE5" }
                  }
                >
                  <div className={styles.col}>S/N</div>
                  <div className={styles.col}>Status</div>
                  <div className={styles.col}>Product Name</div>
                  <div className={styles.col}>Delete</div>
                  <div className={styles.col}>Setting</div>
                  <div className={styles.col}>Edit</div>
                  <div className={styles.col}>View</div>
                </li>
                <div className={styles.Table_row}>
                  {loading.productInfo ? (
                    <Skeleton lines={5} thickness={5} />
                  ) : (
                    filteredData?.collections.map((item, i) => (
                      <li className={styles.tablerow} style={mode
                        ? { backgroundColor: "#1B1D21", color: "#fafafa" }
                        : { backgroundColor: "#ffff" }
                      }
                        onClick={() => navi(`/products/items/${product}/${item?.collection_name}?productId=${product_id}&collectionId=${item?._id}`)}
                        key={`collections - ${item?._id}`}
                      >
                        <div className={styles.col}
                          data-label="Status"
                        >
                          {i + 1}{" "}
                        </div>
                        <div
                          className={styles.col}
                          data-label="Status"
                          style={{ color: TextColorCode(item?.status) }}
                        >
                          {item?.status}{" "}
                        </div>
                        <div
                          className={styles.col}
                          data-label="Product Name"
                          style={{ color: mode ? "#fff" : "#000" }}
                        >
                          {item?.collection_name}
                        </div>
                        <div
                          className={styles.col}
                          data-label="Delete"
                          style={{ color: mode ? "#fff" : "#000" }}
                        >
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSetModel(
                                <>
                                  <ManagerModal
                                    heading={"Delete Product"}
                                    centerHeading={
                                      "Are you sure you want to Delete?"
                                    }
                                    subHeading={
                                      "To confirm! type delete in the text field."
                                    }
                                    targetWord={"delete"}
                                    handleSubmit={() => {
                                      DeleteItem(item._id, "collections");
                                    }}
                                    handleCloseModal={() =>
                                      setModelToggle(false)
                                    }
                                  />
                                </>
                              );
                            }}
                          >
                            {" "}
                            <DeleteTo />{" "}
                          </span>
                        </div>
                        <div
                          className={styles.col}
                          data-label="Setting"
                          style={{ color: mode ? "#fff" : "#000" }}
                        >
                          <SettingTo mode={mode} />
                        </div>
                        <div
                          className={styles.col}
                          data-label="Edit"
                          style={{ color: mode ? "#fff" : "#000" }}
                        >
                          <span onClick={(e) => {
                            e.stopPropagation(); navi(`/products/product/addcollection/${product}?productId=${product_id}&collectionId=${item?._id}`);
                          }}
                          >
                            <EditeTo />{" "}
                          </span>
                        </div>
                        <div
                          className={styles.col}
                          data-label="View"
                          style={{ color: mode ? "#fff" : "#000" }}
                        >
                          <ViewTo />
                        </div>
                      </li>
                    ))
                  )}
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProduct;
